(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamseti-curated-categories-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-lamseti-curated-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    const scrollAmount = () => {
      const card = track.querySelector('.lamseti-curated-carousel__card');
      if (!card) return 0;
      return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    };
    previous?.addEventListener('click', () => track.scrollBy({left:-scrollAmount(),behavior:'smooth'}));
    next?.addEventListener('click', () => track.scrollBy({left:scrollAmount(),behavior:'smooth'}));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamseti-product-details"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.lamseti-product-details').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const tabs = [...section.querySelectorAll('[data-details-tab]')];
      const panels = [...section.querySelectorAll('[data-details-panel]')];

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.detailsTab;

          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.dataset.detailsPanel === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
